function openChat() {
  const global = window

  if (global.jivo_api) {
    global.jivo_api.open()
  }
}

function setUserInfoForChat({ name, email, phone, description }) {
  const global = window

  if (global.jivo_api) {
    global.jivo_api.setContactInfo({
      name,
      email,
      phone,
      description
    })
  }
}

function setDataForChat(data) {
  const global = window

  if (global.jivo_api) {
    global.jivo_api.setCustomData([{ ...data }])
  }
}

module.exports = { openChat, setUserInfoForChat, setDataForChat }
